import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Stack, Typography } from '@mui/material';

import { IBannerItem } from 'api/website';

import useSelectedTheme from 'store/theme';
import useScreen from 'hooks/useScreen';

import DOMPurify from 'dompurify';
import sx from './styles';

interface BannerSlideProps {
  bannerItem: IBannerItem;
  showSpacing?: boolean;
}

const BannerSlide: FC<BannerSlideProps> = ({ bannerItem, showSpacing }) => {
  const navigation = useNavigate();

  const { isMobile } = useScreen();
  const [{ isDark }] = useSelectedTheme();

  const handleClickButton = () => {
    if (bannerItem?.translations[0]?.destinationUrl) {
      if (bannerItem?.translations[0]?.destinationUrl?.includes('http')) {
        window.open(bannerItem?.translations[0]?.destinationUrl, '_blank');
      } else {
        navigation(bannerItem?.translations[0]?.destinationUrl);
      }
    }
  };

  const image = isDark
    ? bannerItem.translations[0].imgDark || bannerItem.translations[0].img
    : bannerItem.translations[0].img || bannerItem.translations[0].imgDark;

  return (
    <Stack
      px={showSpacing ? 1 : 0}
      sx={{ height: '100%', cursor: !bannerItem.translations[0].buttonLabel && 'pointer' }}
      onClick={() => (!bannerItem.translations[0].buttonLabel || isMobile) && handleClickButton()}
    >
      <Box sx={sx.slide({ isMobile, src: image })}>
        {bannerItem.translations[0].title && (
          <Typography
            fontWeight="700"
            mb={isMobile ? 1 : '2vw'}
            fontSize={isMobile ? 20 : 'max(2.2vw, 40px)'}
            lineHeight={isMobile ? '25px' : '2.5vw'}
          >
            {bannerItem.translations[0].title}
          </Typography>
        )}
        {bannerItem.translations[0].description && (
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(bannerItem.translations[0].description),
            }}
          />
        )}
        {!isMobile && bannerItem.translations[0].buttonLabel && (
          <Button variant="contained" onClick={handleClickButton}>
            {bannerItem.translations[0].buttonLabel}
          </Button>
        )}
      </Box>
    </Stack>
  );
};

export default BannerSlide;
